import { Injectable } from '@angular/core';

@Injectable()
export class ExternalRedirectionService {
    public generateUrl(link: string, host?: string, code?: string, creationDate?: string): string {
        const finalLink: URL = (
            link.startsWith('http://') ||
            link.startsWith('https://')
        ) ? new URL(link) : new URL(`http://${link.replace('www.', '')}`);
        if(Boolean(host)){
            finalLink.searchParams.append('host', host);
        }
        if(Boolean(code)){
            finalLink.searchParams.append('code', code);
        }
        if(Boolean(creationDate)){
            finalLink.searchParams.append('creationDate', creationDate);
        }

        return finalLink.toString();
    }

    public redirectTo(link: string, openInNewWindow: boolean = true): void {
        window.open(link, openInNewWindow ? '_blank' : '_self');
    }
}
